var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "user-home-page dashboard-page",
      class: !_vm.isSuperAdmin ? "adjust-apps-container" : ""
    },
    [
      _vm.isSuperAdmin
        ? _c("header4IQ", { attrs: { fromapp: "ug", pagename: "docs" } })
        : _c("headerNew", {
            attrs: { fromapp: "ug", activeApp: "docs", pagename: "docs" }
          }),
      _vm._v(" "),
      _c("main", { staticClass: "main-container" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: "apps" },
          [
            _c(
              "v-container",
              { attrs: { fluid: "", "grid-list-lg": "" } },
              [
                _c(
                  "v-layout",
                  { attrs: { row: "", wrap: "" } },
                  _vm._l(_vm.totalDocs, function(doc, index) {
                    return _c(
                      "v-flex",
                      { key: index, attrs: { lg3: "" } },
                      [
                        _c(
                          "v-card",
                          {
                            staticClass: "apps_card-container",
                            attrs: { id: "docsCard" }
                          },
                          [
                            _c(
                              "v-layout",
                              [
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "apps_company-logo-1",
                                    attrs: { xs4: "", "overflow-hidden": "" }
                                  },
                                  [
                                    _c("div", { staticClass: "name-logo-1" }, [
                                      _vm._v(_vm._s(_vm._f("logoName")(doc)))
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "apps_company-info",
                                    attrs: { xs8: "", "overflow-hidden": "" }
                                  },
                                  [
                                    _c("v-card-text", [
                                      _c(
                                        "div",
                                        { staticClass: "apps_info_body" },
                                        [
                                          _c("h6", {
                                            staticClass: "apps_company-name",
                                            domProps: {
                                              textContent: _vm._s(
                                                doc + " Docs "
                                              )
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "apps_company-service",
                                            domProps: {
                                              textContent: _vm._s(doc)
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "apps_company-username"
                                            },
                                            [_vm._v("App help documentation")]
                                          )
                                        ]
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("v-divider", { staticClass: "purple" }),
                            _vm._v(" "),
                            _c(
                              "v-card-actions",
                              { staticClass: "pa-3" },
                              [
                                _c("h2", {
                                  staticClass: "apps_company-name",
                                  domProps: {
                                    textContent: _vm._s(doc + " Docs ")
                                  }
                                }),
                                _vm._v(" "),
                                _c("v-spacer"),
                                _vm._v(" "),
                                _c(
                                  "v-icon",
                                  {
                                    attrs: { id: "launchDoc" },
                                    on: {
                                      click: function($event) {
                                        return _vm.launchAppDoc(doc, _vm.key)
                                      }
                                    }
                                  },
                                  [_vm._v("open_in_new")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "container-head" }, [
      _c("div", { staticClass: "head-info" }, [
        _c("h5", { staticClass: "container-title" }, [
          _vm._v(" Application - Documents")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }